"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkControls = exports.LinkControlsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
exports.LinkControlsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n  "])))
});
var ControlStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  "], ["\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Control: styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ControlStyles)
};
var LinkControls = function (props) {
  var className = props.className;
  var items = props.items ? (0, lodash_1.isArray)(props.items) ? (0, lodash_1.filter)(props.items) : [props.items] : [];
  return react_1.default.createElement(My.Container, {
    className: className
  }, items.map(function (item, index) {
    return react_1.default.createElement(My.Control, {
      key: "control-".concat(index),
      isLast: index === items.length - 1
    }, item);
  }));
};
exports.LinkControls = LinkControls;
exports.LinkControls.defaultProps = exports.LinkControlsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;